





















































































import Vue from 'vue';
import dayjs from 'dayjs';

export default Vue.extend({
  props: {
    messages: {
      type: Array,
    },
  },
  methods: {
    formatDate(date: string) {
      return dayjs(date).format('dd/MMM - H:mm');
    },
  },
});
